import { useGetBannersQuery } from '../../../../../hooks/banners/queries/useGetBanners.query';
import { MainCarousel } from '../../../../../pages/Home/HomePage/components/MainCarousel';

export const ProductCarouselSection = () => {
  const { data: mainCarouselImages } = useGetBannersQuery({
    searchParam: {
      category: 'CAROUSEL_MAIN',
      outputLocation: 'home',
    },
  });

  if (mainCarouselImages && mainCarouselImages.length > 0) {
    return <MainCarousel carouselImages={mainCarouselImages} pageType={'pdp'} position={'bottom'} />;
  }

  return <></>;
};
